<div class="chat-dialog" (click)="$event.stopPropagation()">
  <div class="chat-dialog__header">
    <div class="chat-dialog__header-left">
      <div class="chat-dialog__header-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 2a4 4 0 0 1 4 4v2a4 4 0 0 1-8 0V6a4 4 0 0 1 4-4z"/>
          <path d="M16 14H8a4 4 0 0 0-4 4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4z"/>
        </svg>
      </div>
      <span class="chat-dialog__header-title">
        {{ mode() === 'general' ? ('chatDialog.quickQuery' | translate) : ('chatDialog.createReport' | translate) }}
      </span>
    </div>
    <div class="chat-dialog__header-actions">
      @if (mode() === 'voice-report' && voiceStep() !== 'select-type') {
        <button class="chat-dialog__header-btn chat-dialog__header-btn--new" (click)="startNewReport()" title="{{ 'chatDialog.newReportTitle' | translate }}">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
          </svg>
          {{ 'chatDialog.new' | translate }}
        </button>
      }
      @if (mode() === 'voice-report') {
        <button
          class="chat-dialog__header-btn chat-dialog__header-btn--fullpage"
          (click)="openFullPage()"
          title="{{ 'chatDialog.fullPageTitle' | translate }}"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
            <path d="M15 3h6v6M10 14 21 3"/>
          </svg>
          {{ 'chatDialog.history' | translate }}
        </button>
      }
      @if (messages().length > 0) {
        <button class="chat-dialog__header-btn" (click)="clear()" title="{{ 'chatDialog.clearTitle' | translate }}">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
          </svg>
        </button>
      }
      <button
        class="chat-dialog__header-btn chat-dialog__header-btn--close"
        (click)="closeRequest.emit()"
        title="{{ 'chatDialog.close' | translate }}"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>
  </div>

  <div class="chat-dialog__messages" #messagesContainer>
    @if (mode() === 'voice-report' && restoredFromDraft()) {
      <!-- 误关/刷新后恢复未提交报告的提示 -->
      <div class="chat-dialog__restored-bar" (click)="dismissRestored()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M1 4v6h6M23 20v-6h-6"/>
          <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
        </svg>
        {{ 'chatDialog.restoredBar' | translate }}
      </div>
    }
    @if (mode() === 'general') {
      <!-- ======= 通用助手 ======= -->
      @if (generalConnectionStatus() === 'connecting') {
        <div class="chat-dialog__empty">
          <div class="chat-dialog__loading-spinner"></div>
          <p class="chat-dialog__empty-text">{{ 'chatDialog.connectingAi' | translate }}</p>
        </div>
      } @else if (generalConnectionStatus() === 'error' && messages().length === 0) {
        <div class="chat-dialog__empty">
          <div class="chat-dialog__empty-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="1.5">
              <circle cx="12" cy="12" r="10"/>
              <line x1="15" y1="9" x2="9" y2="15"/>
              <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>
          </div>
          <p class="chat-dialog__empty-text" style="color:#ef4444;">{{ 'chatDialog.connectAiFailed' | translate }}</p>
        </div>
      } @else if (messages().length === 0) {
        <div class="chat-dialog__empty">
          <div class="chat-dialog__empty-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="1.5">
              <path d="M12 2a4 4 0 0 1 4 4v2a4 4 0 0 1-8 0V6a4 4 0 0 1 4-4z"/>
              <path d="M16 14H8a4 4 0 0 0-4 4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4z"/>
            </svg>
          </div>
          <p class="chat-dialog__empty-text">{{ generalOpeningStatement() || ('chatDialog.aiOpeningDefault' | translate) }}</p>
        </div>
      }
    } @else {
      <!-- ======= 语音报报告 ======= -->
      @if (voiceStep() === 'select-type') {
        <div class="chat-dialog__empty">
          <div class="chat-dialog__empty-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="1.5">
              <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
              <path d="M19 10v2a7 7 0 0 1-14 0v-2M12 19v3"/>
            </svg>
          </div>
          <p class="chat-dialog__empty-text">
            @if (!canVoiceReport()) {
              {{ 'chatDialog.checkinFirst' | translate }}
            } @else {
              {{ 'chatDialog.selectTypeHint' | translate }}
            }
          </p>
          @if (canVoiceReport()) {
            <div class="chat-dialog__suggestions">
              <button class="chat-dialog__suggestion" (click)="selectReportTypeOrHint('OTI')">
                {{ 'chatDialog.otiSuggestion' | translate }}
              </button>
              <button class="chat-dialog__suggestion" (click)="selectReportTypeOrHint('LP')">
                {{ 'chatDialog.lpSuggestion' | translate }}
              </button>
            </div>
          }
        </div>
      } @else if (voiceConnectionStatus() === 'connecting') {
        <div class="chat-dialog__empty">
          <div class="chat-dialog__loading-spinner"></div>
          <p class="chat-dialog__empty-text">{{ 'chatDialog.connectingVoice' | translate }}</p>
        </div>
      } @else if (voiceConnectionStatus() === 'error' && messages().length === 0) {
        <div class="chat-dialog__empty">
          <div class="chat-dialog__empty-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="1.5">
              <circle cx="12" cy="12" r="10"/>
              <line x1="15" y1="9" x2="9" y2="15"/>
              <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>
          </div>
          <p class="chat-dialog__empty-text" style="color:#ef4444;">{{ 'chatDialog.connectVoiceFailed' | translate }}</p>
        </div>
      } @else if (voiceStep() === 'chatting' && messages().length === 0) {
        <!-- 已选类型、尚未开始描述：显示引导提示 -->
        <div class="chat-dialog__hint">
          <div class="chat-dialog__hint-icon">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z"/>
              <path d="M5 11a7 7 0 0 0 14 0M12 18v4"/>
            </svg>
          </div>
          <div class="chat-dialog__hint-body">
            <p class="chat-dialog__hint-title" [innerHTML]="'chatDialog.selectedType' | translate: { type: reportType() }"></p>
            <p class="chat-dialog__hint-sub">{{ voiceHintSub() }}</p>
          </div>
        </div>
      }
    }

    @for (msg of messages(); track trackById($index, msg)) {
      <app-chat-message
        [message]="msg"
        [isStreaming]="msg.role === 'assistant' && msg.status === 'streaming'"
      />
    }

    @if (mode() === 'voice-report' && voiceStep() === 'confirm') {
      <app-report-confirm-card
        [reportType]="reportType()!"
        [fieldDefs]="confirmFieldDefs()"
        [(fields)]="confirmFields"
        [timeAutoComplected]="timeAutoComplected"
        (confirm)="onConfirmSubmit($event)"
        (cancel)="onConfirmCancel()"
      />
    }
  </div>

  @if (mode() === 'voice-report' && voiceStep() === 'completed') {
    <!-- 提交完成后的底部：成功引导 + 新建报告 -->
    <div class="chat-dialog__input-area chat-dialog__input-area--completed">
      <div class="chat-dialog__completed-bar">
        <span>{{ 'chatDialog.completedBar' | translate }}</span>
        <button class="chat-dialog__completed-new" (click)="startNewReport()">{{ 'chatDialog.newReportBtn' | translate }}</button>
      </div>
    </div>
  } @else if (showInputArea()) {
    <div class="chat-dialog__input-area">
      @if (lastErrorMessage) {
        <button class="chat-dialog__retry-bar" (click)="retry()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M1 4v6h6M23 20v-6h-6"/>
            <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
          </svg>
          {{ 'chatDialog.retryBar' | translate }}
        </button>
      }
      <div class="chat-dialog__input-wrapper">
        <!-- 左侧：语音按钮（点击开始/结束录音，录音时绿色闪烁发光） -->
        @if (voiceSupported) {
          <button
            class="chat-dialog__mic-btn"
            [class.chat-dialog__mic-btn--recording]="isRecording()"
            [class.chat-dialog__mic-btn--busy]="isTranscribing() || isStreaming()"
            (click)="toggleRecording()"
            [disabled]="isTranscribing() || isStreaming()"
            [title]="isRecording() ? ('chatDialog.stopRecordingTitle' | translate) : ('chatDialog.startRecordingTitle' | translate)"
          >
            @if (isTranscribing()) {
              <div class="chat-dialog__mic-spinner"></div>
            } @else if (isRecording()) {
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor" stroke="none"/>
              </svg>
            } @else {
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zM5 11a7 7 0 0 0 14 0M12 18v4"/>
              </svg>
            }
          </button>
        }

        <!-- 中间：自适应增高输入框 -->
        <textarea
          #msgInput
          class="chat-dialog__input"
          [(ngModel)]="inputText"
          (keydown)="onKeydown($event)"
          (input)="onInputResize()"
          [placeholder]="'chatDialog.inputPlaceholder' | translate"
          rows="1"
          [disabled]="isStreaming()"
        ></textarea>

        <!-- 右侧：流式中显示停止；有文字显示绿色发送；无文字显示 + 号（扩展占位） -->
        @if (isStreaming()) {
          <button class="chat-dialog__send-btn chat-dialog__send-btn--stop" (click)="cancel()" title="{{ 'chatDialog.stop' | translate }}">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <rect x="6" y="6" width="12" height="12" rx="2"/>
            </svg>
          </button>
        } @else if (hasInputText) {
          <button
            class="chat-dialog__send-btn chat-dialog__send-btn--send"
            (click)="send()"
            title="{{ 'chatDialog.sendTitle' | translate }}"
          >{{ 'chatDialog.send' | translate }}</button>
        } @else {
          <button
            class="chat-dialog__ext-btn"
            (click)="onExtClick()"
            title="{{ 'chatDialog.moreTitle' | translate }}"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
          </button>
        }
      </div>
    </div>
  }
</div>
